import { ApiFactoryClassType } from 'api/factory';
import { FormValues } from 'components/form/types';
import { PaginationTypeResponse } from '../types';

const clientsAdmin = (factory: ApiFactoryClassType) => ({
    getClientList: async (
        limit: number = 15,
        offset: number = 0,
        sort?: string,
        order?: 'asc' | 'desc',
    ): Promise<PaginationTypeResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(
                    `/api/admin/client/list?limit=${limit}&offset=${offset}${sort && order ? `&sort=${sort}&order=${order}` : ``}`,
                    factory.getApiHost(),
                ),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return await response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getClient: async (id: string) => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/admin/client/${id}`, factory.getApiHost()),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return await response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    createClient: async (clientObj: FormValues) => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL('/api/admin/client/create', factory.getApiHost()),
                {
                    method: 'POST',
                    body: JSON.stringify(clientObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                        'Accept-Language': factory.getRequestLocale(),
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    updateClient: async (id: string, userObj: FormValues) => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/admin/client/${id}`, factory.getApiHost()),
                {
                    method: 'PUT',
                    body: JSON.stringify(userObj),
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Content-Type': 'application/json',
                        'Accept-Language': factory.getRequestLocale(),
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
});

export default clientsAdmin;
